import React, { useState, useEffect } from 'react';
import { 
  Layout,  
  Button, 
  Card, 
  Col, 
  Row, 
  Typography,  
  Collapse, 
  Tabs,   
  Form, 
  Input, 
} from 'antd';
import { PlusOutlined, MinusOutlined 
} from '@ant-design/icons'; 
import { Container } from 'react-bootstrap'; 
import DesktopImage from "../../assets/images/desktop.webp" 
import PurposeIcon from "../../assets/images/purpose-icon.webp"
import PeopleIcon from "../../assets/images/people-icon.webp"
import CareerIcon from "../../assets/images/career-icon.webp"
import TabsDesktopIcon from "../../assets/images/plan-tabs-desktop.png"
import CameraIcon from "../../assets/images/camera-icon.svg"
import CalenderIcon from "../../assets/images/calender-icon.svg"
import DocumentIcon from "../../assets/images/document-icon.svg"
import ControlIcon from "../../assets/images/control-icon.svg"
import BlogImage01 from "../../assets/images/blog-image01.jpg"
import BlogImage02 from "../../assets/images/blog-image02.jpg"
import BlogImage03 from "../../assets/images/blog-image03.jpg"
import BlogImage04 from "../../assets/images/blog-image04.jpg"
import BlogImage05 from "../../assets/images/blog-image05.jpg"
import BlogImage06 from "../../assets/images/blog-image06.jpg"
import MessageIcon from "../../assets/images/message-icon.svg" 
import DesignShape from "../../assets/images/blog-shape.png"
  
import FooterIndex from '../Auth/Footer';
import HeaderIndex from '../Auth/Header';



const { Content } = Layout;
const { Title, Text, Paragraph } = Typography;
const { Panel } = Collapse;
const { TabPane } = Tabs;
 

export default function ImergeyWebsite() {
  const [expandedFaq, setExpandedFaq] = useState(null);
 
  const toggleFaq = (index) => {
    if (expandedFaq === index) {
      setExpandedFaq(null);
    } else {
      setExpandedFaq(index);
    }
  };
  
  useEffect(() => {
    // Add custom class to body for global styling
    document.body.classList.add('imergey-body');
    
    return () => {
      document.body.classList.remove('imergey-body');
    };
  }, []);

  // FAQ Data
  const faqData = [
    {
      question: "Lorem ipsum is simply dummy text of the printing and typesetting industry.",
      answer: "It is a long established fact that a reader will be distracted by the readable."
    },
    {
      question: "Lorem ipsum is simply dummy text of the printing and typesetting industry.",
      answer: "Lorem ipsum is simply dummy text of the printing and typesetting industry content."
    },
    {
      question: "Display dummy text of the printing and typesetting industry.",
      answer: "Lorem ipsum is simply dummy text of the printing and typesetting industry content."
    },
    {
      question: "Dummy text of the printing and typesetting industry.",
      answer: "Lorem ipsum is simply dummy text of the printing and typesetting industry content."
    },
    {
      question: "Ipsum is simply dummy text of the printing and typesetting industry.",
      answer: "Lorem ipsum is simply dummy text of the printing and typesetting industry content."
    }
  ];

  // Case Study Data
  const caseStudies = [
    {
      title: "COMPANY CASE STUDY:",
      subtitle: "Case Studies",
      logo: BlogImage01,
      company: "AESOP",
      date: "January 11, 2022"
    },
    {
      title: "COMPANY CASE STUDY:",
      subtitle: "Case Studies",
      logo: BlogImage02, 
      company: "AESOP",
      date: "January 11, 2022"
    },
    {
      title: "COMPANY CASE STUDY:",
      subtitle: "Case Studies",
      logo: BlogImage03,
      company: "AESOP",
      date: "January 11, 2022"
    },
    {
      title: "MEET THE EXPERT:",
      subtitle: "Case Studies",
      logo: BlogImage04,
      company: "AESOP",
      date: "January 11, 2022"
    },
    {
      title: "COMPANY CASE STUDY:",
      subtitle: "Case Studies",
      logo: BlogImage05,
      company: "AESOP",
      date: "January 11, 2022"
    },
    {
      title: "BUSINESS CASE STUDY:",
      subtitle: "KLOOK",
      logo: BlogImage06,
      company: "AESOP",
      date: "January 11, 2022"
    }
  ];

  return (
    <>
    <Layout className="imergey-layout">
      <HeaderIndex />

      {/* Hero Section */}
      <Content>
        <section className="hero-section">
          <div className='hero-banner-shape'>
            <img src={DesignShape} />
          </div>
        <Container>
          <div className="hero-content">
            <h4 className="hero-title">THE FUTURE OF BRAND <span>STRATEGY</span></h4>
            <p className="hero-subtitle">It’s time to look at executives.</p>
            
            <div className="platform-preview">
              <img src={DesktopImage} alt="Platform Preview" className="preview-image" />
            </div>
            
            <div className="hero-buttons">
              <Button  className="trial-btn">
              Start a fee trial!
              </Button>
              <Button  className="demo-btn">
                Book a Demo
              </Button>
            </div>
          </div>
          
          {/* Features */}
          <div className="features-container">
            <div className='tranding-headding'>
              <h6>TRENDING INSIGHTS</h6>
            </div>
            <div className='trandings-insite'> 
                <div className="feature-number">
                  <div className="number-circle">1</div>
                </div>
                <h6>Agentic AI in workplace collaboration How autonomous AI agents will reshape jobs</h6>
            </div>
            <div className='trandings-insite'> 
                <div className="feature-number">
                  <div className="number-circle">2</div>
                </div>
                <h6>Middle East’s Luxury Retail BoomHow Gulf states are redefining high-end shopping.</h6>
            </div>
            <div className='trandings-insite'> 
                <div className="feature-number">
                  <div className="number-circle">3</div>
                </div>
                <h6>The Science of Belonging: Designing Workplaces That Cultivates Connection</h6>
            </div>
          </div>
          </Container>
        </section>

      {/* Who We Are */}
      <section className="who-we-are-section" id='whoweare'>
        <Container>
        <h4 className="section-title">WHO WE ARE</h4>
        
        <Row gutter={[24, 24]} className="who-we-are-container">
          <Col xs={24} sm={12} md={8}>
            <Card className="about-card">
              <div className="icon-circle">
                <img src={PurposeIcon} className="about-icon" />
              </div>
              <h6 className="card-title">Our Purpose</h6>
              <p className="card-description">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur voluptas quas amet nostrum deleniti asperiores sequi perferendis.
              </p>
            </Card>
          </Col>
          
          <Col xs={24} sm={12} md={8}>
            <Card className="about-card highlight">
              <div className="icon-circle">
              <img src={PeopleIcon} className="about-icon" />
              </div>
              <h6 className="card-title">Our people</h6>
              <p className="card-description">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur voluptas quas amet nostrum deleniti asperiores sequi perferendis.
              </p>
            </Card>
          </Col>
          
          <Col xs={24} sm={12} md={8}>
            <Card className="about-card">
              <div className="icon-circle">
              <img src={CareerIcon} className="about-icon" />
              </div>
              <h6 className="card-title">Your Control</h6>
              <p className="card-description">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur voluptas quas amet nostrum deleniti asperiores sequi perferendis.
              </p>
            </Card>
          </Col>
        </Row>
        </Container>
      </section>

      {/* Plan, approve, achieve */}
      <section className="plan-section" id='whatwedo'>
        <Container>
        <div className="plan-header">
          <h6 className="subtitle">What we do</h6>
          <h2 className="section-title">Plan, approve, achieve.</h2>
          <p>Yes, indeed – it's that simple. Take our showcase for a ride and see for yourself.</p>
        </div>
        
        <Tabs defaultActiveKey="1" centered className="feature-tabs">
          <TabPane tab="Dashboard" className='tabs-button' key="1" >
            <div className="dashboard-preview">
              <img src={TabsDesktopIcon} alt="Dashboard Preview" className="preview-img" />
            </div>
          </TabPane>
          <TabPane tab="Calendar" className='tabs-button' key="2">
            <div className="dashboard-preview">
              <img src={TabsDesktopIcon} alt="Calendar Preview" className="preview-img" />
            </div>
          </TabPane>
          <TabPane tab="AI Research" className='tabs-button' key="3">
            <div className="dashboard-preview">
              <img src={TabsDesktopIcon} alt="AI Research Preview" className="preview-img" />
            </div>
          </TabPane>
          <TabPane tab="Human Touch" className='tabs-button' key="4">
            <div className="dashboard-preview">
              <img src={TabsDesktopIcon} alt="Human Touch Preview" className="preview-img" />
            </div>
          </TabPane>
          <TabPane tab="Report" className='tabs-button' key="5">
            <div className="dashboard-preview">
              <img src={TabsDesktopIcon} alt="Report Preview" className="preview-img" />
            </div>
          </TabPane>
        </Tabs>
        </Container>
      </section>

      {/* Features Grid */}
      <section className="features-grid-section" id='howitwork'>
      <Container>
        <div className="section-header">
          <h6 className="subtitle">How it Works</h6>
          <h4 className="section-title">We help you grow where it matters most on Imergey.</h4>
        </div>
        
        <div className="feature-grid">
       
            <div className="feature-grid-card">
              <div className="feature-icon-container">
                <img src={CameraIcon} className="feature-icon" />
              </div>
              <h6 className="feature-title">User Management & Role-based Access</h6>
              <p className="feature-text">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur voluptas quas amet.
              </p>
            </div> 
            <div className="feature-grid-card">
              <div className="feature-icon-container">
                <img src={CalenderIcon}  className="feature-icon" />
              </div>
              <h6 className="feature-title">Peer Scheduling & Controlled View</h6>
              <p className="feature-text">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur voluptas quas amet.
              </p>
            </div> 
            <div className="feature-grid-card">
              <div className="feature-icon-container">
                <img src={DocumentIcon}  className="feature-icon" />
              </div>
              <h6 className="feature-title">Work for Document & Asset Management</h6>
              <p className="feature-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur voluptas quas amet.</p>
            </div> 
            <div className="feature-grid-card">
              <div className="feature-icon-container">
                <img src={ControlIcon}  className="feature-icon" />
              </div>
              <h6 className="feature-title">Customizable Access Control</h6>
              <p className="feature-text"> Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur voluptas quas amet.</p>
            </div> 
        </div>
        </Container>
      </section>

      {/* Case Studies */}
      <section className="case-studies-section" id='insights'>
          <div className='hero-banner-shape'>
            <img src={DesignShape} />
          </div>
      <Container>
        <div className="plan-header">
          <h6 className="subtitle">Insights</h6>
          <h2 className="section-title">What Our Users Are Saying</h2>
        </div>
        
        <div className="case-studies-card">
          {caseStudies.map((study, index) => (
            <div className='blog-card' key={index}>
            
                  <div className="case-study-image-container">
                    <img src={BlogImage01} alt={study.subtitle} className="case-study-image" />
                    <div className="case-study-overlay">
                      <h6 className="case-study-category">{study.title}</h6>
                      <p className="case-study-title"><span>January 10, 2025</span>{study.subtitle}</p>
                    </div>
                  </div>
               
            </div>
          ))}
        </div>
        </Container>
      </section>

      {/* FAQ Section */}
      <section className="faq-section" id='faq'>
      <Container>
        <div className="faq-container">
          <div className='faq-headding'>
              <h6 className="section-title">FAQ's</h6>
              <h4 className="faq-subtitle">Frequently Asked Questions</h4>
              <p>Lorem ipsum dolor sit amet consectetur. Nunc in rutrum eu ipsum volutpat. Condimentum rhoncus aenean viverra imperdiet elementum Lorem ipsum dolor sit amet consectetur. Nunc in rutrum eu ipsum volutpat. Condimentum rhoncus aenean viverra imperdiet elementum</p>
          </div>
          <Collapse 
            className="faq-collapse" 
            bordered={false} 
            expandIconPosition="right"
            expandIcon={({ isActive }) =>
              isActive ? <MinusOutlined /> : <PlusOutlined />
            }
            accordion
          >
            {faqData.map((faq, index) => (
              <Panel 
                header={faq.question} 
                key={index} 
                className="faq-panel"
                
              >
                <Text className="faq-answer">{faq.answer}</Text>
              </Panel>
            ))}
          </Collapse>
        </div>
        </Container>
      </section>

      {/* Newsletter */}
      <section className="newsletter-section">
        <Container>
        <div className="newsletter-card">
            <div className="mail-icon-wrapper">
              <img src={MessageIcon} className="mail-icon" />
            </div>
            <h6 className="newsletter-title">Subscribed Newsletter</h6>
             <p className="newsletter-desc">Lorem Ipsum is text of the printing and typesetting industry.
            It is a long established fact that a reader will be distracted by at its layout. </p>
            <div className='newslatter-input'>
              <Input className='input-inn' placeholder='user@gmail.com' />
              <Button className='subcribe-btn'>Subscribe</Button>
            </div>
          </div> 
          </Container>
        </section>

    <FooterIndex />
     </Content> 
     </Layout>
   

    </>
  );
}